import InmuebleRentaTemplate from "../../components/templates/inmuebles/InmuebleRentaTemplate"

const InmuebleRenta = () => {
    return <InmuebleRentaTemplate/>;
};

export default InmuebleRenta;